import api from './client';
import type { ApiResponse } from '@/types/generic';

export interface MockLoginResponse {
  accessToken: string;
  mockLoginId: string;
  expiresAt: string;
  role: string;
}

export async function startMockLogin(userId: string, portal: 'employee' | 'company' = 'employee') {
  return api.post<ApiResponse<MockLoginResponse>>(
    `/mock-login/${userId}/start`,
    { portal }
  );
}

export async function stopMockLogin(sessionId: string) {
  const { data } = await api.post(`/mock-login/${sessionId}/stop`);
  return data;
}
